<zef-button-progress
  satPopoverAnchor
  [buttonRef]="buttonRef()"
  class="__button-progress"
  [class.is-disabled]="effectiveDisabled()"
  [disabled]="effectiveDisabled()"
  [class.has-errors]="state.errorData?.length"
  [active]="progressActiveSignal() || loading()">
  <ng-content />
</zef-button-progress>

<sat-popover
  [autoFocus]="false"
  [hasArrow]="true"
  [verticalAlign]="popVerticalAlign()"
  [horizontalAlign]="popHorizontalAlign()"
  (closed)="onPopoverClosed$.next()"
  [anchor]="popoverAnchorRef()">
  @if (tpl(); as template) {
    <ng-template
      [ngTemplateOutlet]="template"
      [ngTemplateOutletContext]="{
        data: state.errorsActive,
        instance: popoverAnchorRef()?.popover
      }"
    />
  }
</sat-popover>
